import { createReducer, on } from '@ngrx/store';
import { Order } from '@app/services/order/order.model';
import { PreviewOrdersActions } from '../actions';

export const featureKey = 'orders';

export interface State {
  orders: Order[];
  countOrders: number;
  loading: boolean;
}

export const initialState: State = {
  orders: null,
  countOrders: null,
  loading: false,
};

export const reducer = createReducer(
  initialState,
  on(PreviewOrdersActions.loadPreviewOrders, (state: State) => ({
    ...state,
    loading: true,
  })),
  on(PreviewOrdersActions.loadPreviewOrdersSuccess, (state: State, { orders, count }) => ({
    ...state,
    orders,
    countOrders: count,
    loading: false,
  })),
  on(PreviewOrdersActions.loadPreviewOrdersFailure, (state: State) => ({
    ...state,
    orders: null,
    countOrders: null,
    loading: false,
  })),
  on(PreviewOrdersActions.loadPreviewOrdersCount, (state: State) => ({
    ...state,
    loading: true,
  })),
  on(PreviewOrdersActions.loadPreviewOrdersCountSuccess, (state: State, { count }) => ({
    ...state,
    countOrders: count,
    loading: false,
  })),
  on(PreviewOrdersActions.loadPreviewOrdersCountFailure, (state: State) => ({
    ...state,
    orders: null,
    countOrders: null,
    loading: false,
  })),
  on(PreviewOrdersActions.setPreviewOrdersLoading, (state: State, { loading }) => ({
    ...state,
    loading,
  })),
);

export const getOrders = (state: State): Order[] => state.orders;
export const getCountOrders = (state: State): number => state.countOrders;
export const getLoading = (state: State): boolean => state.loading;
